module.exports = __webpack_public_path__ + "img/logo-footer.22fe7160.svg";